<template>
  <PopUp
    v-if="active"
    bottom
    :popUpActive="active"
    :clickOutsideClose="false"
    @click="$_onClosePopup()"
  >
    <div v-if="title" class="popup-title">
      <p class="title">
        <i class="icon-edit-pencil" /> {{ title }}
      </p>
    </div>
    <InputListCard>
      <div class="input-item">
        <LvFlexBox justifyContent="space-between">
          <LvText h6>
            {{ $t('請寫下檢查當場處理情況、以及填報當場未能解決之問題。') }}
          </LvText>
          <LvUploadFileBtn
            multiple
            type="text"
            btnText="附件"
            :uploadModule="uploadModule"
            :selectedFileList="C_images"
            @input="$_onInput($event, 'C_images')"
          />
        </LvFlexBox>
        <div class="input">
          <WsInputTextareaButton001
            :value="remark"
            :placeholder="$t('輸入')"
            :min-height="134"
            @input="$_onInput($event, 'C_remark')"
          />
        </div>
      </div>
      <div v-if="C_images.length > 0">
        <LvFileList
          outline
          twoItem
          showDeleteBtn
          :value="C_images"
          :marginTop="20"
          :module="uploadModule"
          @go-to="$_onGoToFile($event)"
          @delete-file="$_onDeleteImages($event)"
        />
      </div>
    </InputListCard>
    <template v-slot:bottomBtn>
      <WsButton001
        out-line
        width200
        @click="$_onClosePopup()"
      >
        {{ $t('取消') }}
      </WsButton001>
      <WsButton001
        width200
        :disable="!C_remark.trim()"
        @click="$_onSubmit()"
      >
        {{ $t('完成') }}
      </WsButton001>
    </template>
  </PopUp>
</template>
<script>
import H_file from '@/helpers/file';
import H_common from '@/helpers/common';

export default {
  props: {
    images: {
      type: Array,
    },
    remark: {
      type: String,
    },
    title: {
      type: String,
    },
    active: {
      type: Boolean,
      default: false,
    },
    uploadModule: {
      type: String,
    }
  },
  data() {
    return {
      C_remark: '',
      C_images: [],
    }
  },
  mounted() {
    if (this.remark !== undefined) this.C_remark = this.remark;
    if (this.images !== undefined) this.C_images = H_common.deepCopyFunction(this.images);
  },
  methods: {
    async $_onClosePopup() {
      this.C_remark = '';
      this.C_images = [];
      this.$emit("popup-close");
    },
    $_onGoToFile($event) {
      H_file.goToFile($event);
    },
    $_onDeleteImages(index) {
      this.C_images.splice(index, 1);
    },
    $_onInput($event, key) {
      let value = $event;
      if (key === 'C_images') {
        value = this.C_images && this.C_images.length
          ? [...this.C_images, ...$event]
          : $event;
      }
      this[key] = value;
    },
    $_onSubmit() {
      this.$emit('submit', {
        remark: this.C_remark,
        images: this.C_images,
      });
      this.$emit("popup-close");
    }
  },
  watch: {
    images() {
      if (this.images !== undefined) this.C_images = H_common.deepCopyFunction(this.images);
    },
    remark() {
      if (this.remark !== undefined) this.C_remark = this.remark;
    },
  },
};
</script>